import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Chapter } from "./Chapter";

export const Programs = () => {
  const { t } = useLang();
  return (
  <section id="programs" data-testid="programs-section" className="py-24 md:py-32">
    <div className="px-6 lg:px-10 max-w-7xl mx-auto">
      <Chapter number="01" overline={t.chapters.programs.overline} title={t.chapters.programs.title} />
    </div>

    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      {[...t.programs].sort((a, b) => a.id.localeCompare(b.id)).map((p, i) => (
        <div key={p.id} className="lg:sticky" style={{ top: `${80 + i * 24}px`, zIndex: i + 1 }}>
          <motion.article
            data-testid={`program-card-${p.id}`}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="bg-graphite border border-line mb-8 grid grid-cols-1 lg:grid-cols-2 overflow-hidden"
          >
            <div className="p-8 md:p-12 flex flex-col justify-between min-h-[380px]">
              <div>
                <div className="flex items-baseline justify-between gap-4 mb-8">
                  <span className="font-mono text-xs tracking-[0.3em] text-dim">/{p.id}</span>
                  <span className={`font-mono text-xs tracking-[0.2em] ${p.current ? "text-volt" : "text-dim"}`}>{p.years}</span>
                </div>
                <h3 className="font-heading font-extrabold tracking-tighter text-3xl md:text-5xl text-paper">
                  {p.name}
                </h3>
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-volt mt-3">{p.subtitle}</p>
                <p className="font-body text-sm md:text-base text-dim mt-6 leading-relaxed max-w-lg">{p.text}</p>
              </div>
              <div className="flex flex-wrap gap-2 mt-8">
                {p.metrics.map((m) => (
                  <span key={m} className="font-mono text-[10px] md:text-xs tracking-[0.15em] border border-line px-3 py-1.5 text-paper">
                    {m}
                  </span>
                ))}
              </div>
            </div>
            <div className="relative min-h-[240px] lg:min-h-full border-t lg:border-t-0 lg:border-l border-line overflow-hidden group">
              <img
                src={p.image}
                alt={p.name}
                className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-graphite/80 to-transparent" />
              {p.current && (
                <span className="absolute top-6 right-6 font-mono text-[10px] tracking-[0.25em] bg-volt text-ink px-3 py-1.5">
                  {p.badge}
                </span>
              )}
            </div>
          </motion.article>
        </div>
      ))}
    </div>
  </section>
  );
};
